import { RelatedDocument } from './related-document.model';

export interface FinancialDocument {
    amount: number;
    applyDiscount: boolean;
    balance: number;
    checked?: boolean;
    companyCode: string;
    countryCode: string;
    contract: string;
    createDate: string;
    createDateObj?: Date;
    createDateTimestamp?: number;
    currencyCode: string;
    customerCode: string;
    customerJobsiteNumber: string;
    daysOverDue: number;
    daysToDue: number;
    debitFlag: boolean;
    discount: number;
    dispute: boolean;
    disputeStatusCode: string;
    disputeStatusDesc: string;
    disputeCompromiseDate: string;
    disputeCompromiseDateObj?: Date;
    disputeId: number;
    disputeResolutionDate: string;
    disputeResolutionDateObj: Date;
    disputeCode: number;
    divisionCode: string;
    docStatusCode: string;
    docStatusDesc: string;
    documentCode: FinancialDocumentStatus | string;
    documentId: number;
    documentItem: string;
    documentTypeCode: string;
    documentTypeDesc: string;
    dueDate: string;
    dueDateObj?: Date;
    dueDateTimestamp?: number;
    fiscalControlNumber: string;
    index?: number;
    invoiceReviewed: boolean;
    invoiceReviewedDesc?: string;
    jobNumber: string;
    jobSiteCode: string;
    jobSiteDesc: string;
    paymentFlag: boolean;
    paymentProcessFlag: boolean;
    paymentsBalance: number;
    plantDesc: string;
    purchaseOrder: string;
    ppdDueDate?: string;
    ppdDueDateObj?: Date;
    relatedPurchaseOrders?: Array<RelatedDocument>;
    relatedContracts?: Array<RelatedDocument>;
    referenceNumber: string;
    relatedDocument: string;
    recordBlocked: number;
    salesOrgCode: string;
    salesOfficeCode: string;
    totalContracts: number;
    totalPO: number;
    isSpecialInvoice?: boolean;
    trafficLightId?: number;
    payment?: number;
    expectedPayment?: number;
    accountingFiscalYear?: number;
    taxRate: number;
////////////////////////////////////////////////////////////
    // for DocumentsDTO used in Reconcile.component.ts
    flagDBExist?: boolean;
    duplicateFlag?: boolean;
    errAmntClearing?: boolean;
    errFlagClearing?: boolean;
    errMsgClearing?: string;
    isApply?: boolean;
    originalAmount?: number;
////////////////////////////////////////////////////////////
    // Acces log
    blobDateCreate?: Date;
    viewDateCreate?: Date;
    customerDesc?: string;
    downloadedBy?: string;

    formattedCreateDate?: string;
    formattedDueDate?: string;
    formattedPPDDueDate?: string;
    formattedDisputeCompromiseDate?: string;
    formattedAmount?: string;
    formattedBalance?: string;
}

export enum FinancialDocumentStatus {
    PaymentInProcess = 'PP',
    ConfirmedByBank = 'B',
    Closed = 'CL',
    UnderVerification = 'Q',
    Pending = 'PE',
    Overdue = 'OV'
}
